// Template202: Bangkok - Transporte (Subway.jsx). borderRadius: "12px".

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template202 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const headerText = page?.texts?.[0]?.content ?? "Transporte en Bangkok";
	const intro = page?.texts?.[1]?.content;
	const consejosTitle = page?.texts?.[2]?.content ?? "Consejos";
	const consejosHtml = page?.texts?.[3]?.content;
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};
	const stickerUrl = getCanvasImageUrl("sticker");
	const actualHeaderColor = headerBackgroundColor || "#e8a838";
	const transportItems = Array.isArray(page?.data?.transportItems)
		? page.data.transportItems
		: [];
	const consejos = Array.isArray(page?.data?.consejos)
		? page.data.consejos
		: [];

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};
	const blockStyle = {
		backgroundColor: "#fff",
		borderRadius: "12px",
		padding: "12px 14px",
		display: "flex",
		alignItems: "center",
		gap: "10px",
		border: "2px solid #d9e6de",
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
			</Box>
			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "16px", fontSize: 13, color: "#444" }}>
					<Box component="p" sx={p}>
						{intro}
					</Box>
				</Box>
			)}
			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
					position: "relative",
				}}
			>
				{stickerUrl && (
					<Box
						component="img"
						src={stickerUrl}
						alt=""
						sx={{
							width: 100,
							position: "absolute",
							bottom: isSmallScreen ? -60 : 0,
							right: 0,
						}}
					/>
				)}
				{transportItems.map((item, i) => (
					<Box key={i} data-block-id={`text-${i + 3}`} sx={blockStyle}>
						<Box sx={{ fontSize: 18 }}>{item.icono ?? "🚇"}</Box>
						<Box sx={{ fontSize: 13, color: "#444" }}>
							{item.texto ? (
								<span dangerouslySetInnerHTML={{ __html: item.texto }} />
							) : (
								item.textoPlain
							)}
						</Box>
					</Box>
				))}
				{(consejosTitle || consejos.length > 0 || consejosHtml) && (
					<Box
						data-block-id="text-consejos"
						sx={{
							backgroundColor: "#FFF3CD",
							border: "3px solid #E8A838",
							borderRadius: "12px",
							padding: "12px 14px",
							fontSize: 13,
							color: "#333",
						}}
					>
						{consejosTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: "13px",
									fontWeight: 700,
									color: "#E8A838",
									textTransform: "uppercase",
								}}
							>
								{consejosTitle}
							</Box>
						)}
						{consejosHtml && (
							<Box
								component="div"
								sx={{
									"& ul": { paddingLeft: 2.5, margin: 0, lineHeight: 1.5 },
								}}
								dangerouslySetInnerHTML={{ __html: consejosHtml }}
							/>
						)}
						{consejos.length > 0 && !consejosHtml && (
							<Box
								component="ul"
								sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.5 }}
							>
								{consejos.map((c, i) => (
									<Box component="li" key={i} sx={p}>
										{c}
									</Box>
								))}
							</Box>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template202.thumbnail = "/images/template-1.png";
export default Template202;
